import { render } from "./ModelBuilding.vue?vue&type=template&id=d15f2e06&ts=true"
import script from "./ModelBuilding.vue?vue&type=script&lang=ts"
export * from "./ModelBuilding.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__